import View from './View';
import schema from './schema';
import icon from '@plone/volto/icons/server.svg';

const AccordionBlock = {
  id: 'accordion',
  title: 'Accordion',
  view: View,
  icon: icon,
  group: 'castle',
  restricted: false,
  mostUsed: false,
  sidebarTab: 1,
  blockSchema: schema,
};

export default AccordionBlock;